export function resolveConnectorShapeState<T extends Record<string, unknown>>(
  historyActive: boolean,
  shapeId: string,
  baseState: T,
  getShapeState?: (shapeId: string, baseState: T) => T,
): T {
  if (historyActive || !getShapeState) return baseState;
  return getShapeState(shapeId, baseState);
}
